export const validName = (name?: string | null): boolean => {
  return name !== "-" && !!name;
};
